import React from 'react';

import { Container } from './styles';

const HeaderBackground: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default HeaderBackground;
